import React, { useLayoutEffect, useRef } from 'react';
import { useResponseContext } from 'js/engines/CapabilitiesAssessment/ResponseContext';
import PageIndicator from './PageIndicator';
import classNames from 'classnames';
import { getPageTitle } from 'js/engines/CapabilitiesAssessment/utils';

/**
 * Shares the slider's height with its container, so content pinned below it
 * (a capability page's answer scale) can sit right under it.
 */
function useSliderHeightVariable(ref) {
  useLayoutEffect(() => {
    const slider = ref.current;
    const container = slider?.parentElement;
    if (!slider || !container) {
      return;
    }

    const update = () => {
      container.style.setProperty(
        '--progress-slider-height',
        `${slider.offsetHeight}px`
      );
    };
    update();

    const observer = new ResizeObserver(update);
    observer.observe(slider);
    return () => {
      observer.disconnect();
      container.style.removeProperty('--progress-slider-height');
    };
  }, [ref]);
}

const ProgressSlider = ({ assessment, currentPageIndex }) => {
  const pages = assessment.document.pages;
  const currentPage = pages[currentPageIndex];
  const { responses } = useResponseContext();
  const ref = useRef(null);
  useSliderHeightVariable(ref);

  return (
    <div className="progress-slider" ref={ref}>
      <div className="progress-text">
        Step {currentPageIndex + 1} of {pages.length}:{' '}
        {getPageTitle(currentPage, assessment.document.capabilitySetCache)}
      </div>
      <div className="pages">
        {pages.map((page, index) => {
          return (
            <PageIndicator
              className={classNames({
                past: currentPageIndex > index,
                current: currentPageIndex === index,
                future: currentPageIndex < index,
              })}
              key={page.guid}
              page={page}
              assessment={assessment}
              responses={responses}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProgressSlider;
